export enum editUserDetailsActions {
  UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS',
  UPLOAD_PROFILE_PHOTO = 'UPLOAD_PROFILE_PHOTO',
  UPDATE_USER_WITH_PROFILE_PHOTO = 'UPDATE_USER_WITH_PROFILE_PHOTO',
}
